module.exports = __webpack_public_path__ + "static/media/quran.accb945c.svg";